import { CheckIcon } from "@heroicons/react/24/solid";

export default function Stepper({ steps, current }) {
  const currentIndex = steps.findIndex((s) => s.key === current);
  return (
    <ol aria-label="Progress" className="space-y-6">
      {steps.map((step, i) => {
        const state = i < currentIndex ? "done" : i === currentIndex ? "current" : "todo";
        return (
          <li
            key={step.key}
            data-state={state}
            aria-current={state === "current" ? "step" : undefined}
            className="flex items-start gap-3"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm ${
                state === "done"
                  ? "bg-gray-900 dark:bg-gray-700 text-white"
                  : state === "current"
                    ? "bg-blue-600 text-white"
                    : "border border-gray-300 dark:border-gray-800 text-gray-500 dark:text-gray-400"
              }`}
            >
              {state === "done" ? <CheckIcon className="h-4 w-4" aria-hidden="true" /> : i + 1}
            </span>
            <span>
              <span className={`block font-medium ${state === "todo" ? "text-gray-500 dark:text-gray-400" : "text-gray-900 dark:text-gray-50"}`}>
                {step.title}
              </span>
              <span className="block text-sm text-gray-500 dark:text-gray-400">{step.subtitle}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
